<template>
    <div>
        <div class="right" style="padding-bottom: 2vh" v-if="!disabled">
            <ButtonField text="添加" primary @click="add"/>
        </div>

        <Tablelist  style="margin-top: 1rem"
                    :showCheckbox="false"
                    :list="selected"
                    :totalSize="totalSize"
                    :totalPages="totalPages"
                    :pageNum="pageNum"
                    :pageSize="pageSize"
                    :columns="tableColumns">
            <template #template-charger="{ item }">
                {{ item.charger ? item.charger : item.chargerOld }}
            </template>
            <template #template-chargerNewId="{ item }">
                <div v-if="disabled">{{ item.chargerNew }}</div>
                <SelectField v-else labelWidth="0" style="width:60%;" :options="userList"
                             v-model="item.chargerNewId" id="chargerNewId" placeholder="现保管人"
                             @update:modelValue="(value) => handleModelValueUpdate('chargerNewId', value)"
                />
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" class="danger" @click.prevent="remove(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" :modelValue="visible"
               contentWidth="800px"
               :visible="visible" :title="'选择资产'" :showFooter="false" :overlayOpacity="0.5" @update:visible="visible = $event">
            <Tablelist  style="margin-top: 1rem"
                        :showCheckbox="true"
                        :list="list"
                        :totalSize="totalSizeAdd"
                        :totalPages="totalPagesAdd"
                        :pageNum="pageNumAdd"
                        :pageSize="pageSizeAdd"
                        :columns="tableColumnsAdd"
                        :selectedItems="globalSelectedItems"
                        @page-change="onChange"
                        @submit-selection="handleSubmitSelection"
            >
            </Tablelist>

        </Modal>
    </div>
</template>

<script>
import { fetchList } from "../../api/list";
import Modal from '@/components/water-affairs-style/modal.vue';
import Tablelist from "@/components/water-affairs-style/table-list.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";
export default {
    components: {
        ButtonField,Tablelist,Modal
    },
    props: {
        selected: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
            total: 0,
            selectedRowKeys: [],
            selectedRows: [],
            visible: false,
            globalSelectedItems: {},
            tableColumns: [
                {
                    key: 'code',
                    title: '资产编号',
                    field: 'code',
                    infotype: 'text'
                },
                {
                    key: 'name',
                    title: '资产名称',
                    field: 'name',
                    infotype: 'text',
                },
                {
                    key: 'brand',
                    title: '品牌',
                    field: 'brand',
                    infotype: 'text',
                },
                {
                    key: 'specification',
                    title: '规格型号',
                    field: 'specification',
                    infotype: 'text',
                },
                {
                    key: 'unit',
                    title: '单位',
                    field: 'unit',
                    infotype: 'text',
                },
                {
                    key: 'price',
                    title: '单价(元)',
                    field: 'price',
                    infotype: 'text',
                },
                {
                    key: 'charger',
                    title: '原保管人',
                    field: 'charger',
                    infotype: 'template',
                },
                {
                    key: 'chargerNewId',
                    title: '现保管人',
                    field: 'chargerNewId',
                    infotype: 'template',
                },
                {
                    key: 'actions',
                    title: '操作',
                    infotype: 'template',
                }
            ],
            tableColumnsAdd: [
                {
                    key: 'code',
                    title: '资产编号',
                    field: 'code',
                    infotype: 'text'
                },
                {
                    key: 'name',
                    title: '资产名称',
                    field: 'name',
                    infotype: 'text',
                },
                {
                    key: 'brand',
                    title: '品牌',
                    field: 'brand',
                    infotype: 'text',
                },
                {
                    key: 'specification',
                    title: '规格型号',
                    field: 'specification',
                    infotype: 'text',
                },
                {
                    key: 'unit',
                    title: '单位',
                    field: 'unit',
                    infotype: 'text',
                },
                {
                    key: 'price',
                    title: '单价(元)',
                    field: 'price',
                    infotype: 'text',
                }
            ],
            totalSize: 1,
            totalPages: 1,
            pageNum: 1,
            pageSize: 10,
            totalSizeAdd: 1,
            totalPagesAdd: 1,
            pageNumAdd: 1,
            pageSizeAdd: 10,
        };
    },

    mounted() {
        this.getList();
    },

    methods: {
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        handleSubmitSelection(selectedItems) {
            const selectedIds = Object.keys(selectedItems);
            selectedIds.forEach(id => {
                const item = this.list.find(item => item.id === id);
                if (item) {
                    const existingItem = this.selected.find(selectedItem => selectedItem.id === item.id);
                    if (!existingItem) {
                        this.selected.push(item);
                    }
                }
            });
            this.visible = false;
        },
        getList() {
            fetchList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                statusList: ["AVAILABLE"],
            }).then((res) => {
                if (res && Array.isArray(res.list)) {
                    this.list = Object.freeze(res.list);
                    this.totalSizeAdd = res.totalSize;
                    this.totalPagesAdd = res.totalPages;
                }
            });
        },

        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getList();
        },

        onSelectChange(keys) {
            console.log("keys", keys);
            this.selectedRowKeys = keys;
            keys.forEach((key) => {
                const item = this.list.find((item) => item.id === key);
                if (item) {
                    this.selectedRows.push(item);
                }
            });
            this.selectedRows = [...new Set(this.selectedRows)];
        },

        add() {
            this.visible = true
        },

        remove(index) {
            this.selected.splice(index, 1);
        },

        cancel() {
            this.visible = false;
            this.selectedRowKeys = [];
            this.selectedRows = [];
        },
        ok() {
            this.selectedRows.forEach((item) => {
                const element = this.selected.find((element) => element.id === item.id);
                if (!element) {
                    this.selected.push(item);
                }
            });
            this.cancel();
        },
    },
};
</script>